module.exports = __webpack_public_path__ + "img/imgBuy.624b56cc.png";